<cipo-dialog-header title="Edit Form Structure" />
<mat-dialog-content>
    <app-form-builder />
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-button [mat-dialog-close]="undefined">{{ "general.cancel" | translate }}</button>
    <button mat-button mat-raised-button color="primary" [disabled]="false" (click)="onSave()">
        {{ "general.save" | translate }}
    </button>
</mat-dialog-actions>
